module.exports = __webpack_public_path__ + "img/album16_01.ba13d465.jpg";